import { zonoApi } from '../api';
import {
  TripCheckInHistoryRequest,
  TripCheckInHistoryResponse,
  TripCheckinRequest,
  TripCheckoutRequest,
  TripClockInHistoryRequest,
  TripClockInHistoryResponse,
  TripClockinRequest,
  TripClockinResponse,
  TripClockoutRequest,
  TripClockoutResponse,
  TripVisitResponse,
} from './trip-model';

export const tripApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    tripCheckin: builder.mutation<TripVisitResponse, TripCheckinRequest>({
      query(arg) {
        return {
          url: `hub/orgs/api/visit/check-in`,
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
    }),
    tripCheckout: builder.mutation<TripVisitResponse, TripCheckoutRequest>({
      query(arg) {
        return {
          url: `hub/orgs/api/visit/check-out`,
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
    }),
    tripClockin: builder.mutation<TripClockinResponse, TripClockinRequest>({
      query(arg) {
        return {
          url: 'hub/orgs/api/trip/clock-in',
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
    }),
    tripClockout: builder.mutation<TripClockoutResponse, TripClockoutRequest>({
      query(arg) {
        return {
          url: 'hub/orgs/api/trip/clock-out',
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
      invalidatesTags: ['trip'],
    }),
    tripClockInHistory: builder.query<
      TripClockInHistoryResponse,
      TripClockInHistoryRequest
    >({
      query(arg) {
        const { isToday, ...params } = arg;
        return {
          url: 'hub/orgs/api/trip',
          method: 'GET',
          params: params,
          headers: {
            'Cache-control': 'no-cache',
          },
        };
      },
    }),
    tripCheckInHistory: builder.query<
      TripCheckInHistoryResponse,
      TripCheckInHistoryRequest
    >({
      query(arg) {
        return {
          url: 'hub/orgs/api/visit/me',
          method: 'GET',
          params: arg,
          headers: {
            'Cache-control': 'no-cache',
          },
        };
      },
    }),
  }),
});

export const {
  useTripClockinMutation,
  useTripClockoutMutation,
  useTripCheckinMutation,
  useTripCheckoutMutation,
  useLazyTripClockInHistoryQuery,
  useLazyTripCheckInHistoryQuery,
} = tripApi;
